import React, { useEffect } from "react";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import withIntl from "../../../utils/withIntl";
import { makeStyles } from "@material-ui/core/styles";
import { DialogActions, IconButton, TextField, Typography } from "@material-ui/core";
import { useDialog } from "../../Dialogs/DialogProvider";
import { Close } from "@material-ui/icons";
import Button from "@material-ui/core/Button";
import { Modifierarticle } from "../../../store/articles/models/Modifierarticle";
import articlesStore from "../../../store/articles/ArticlesStore";
import { Autocomplete } from "@material-ui/lab";
import EditSwitch from "../../EditArticle/EditSwitch";
import GetCurrency from "../../../helper/GetCurrency";
import { updateModifiergroups } from "../../../store/articles/ModifiergroupsApi";
import cloudStore from "../../../store/CloudStore";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(() => ({
  listAllergens: {
    display: "flex",
  },
  section: {
    // border: "2px solid black",
    marginBottom: 10,
  },
  section2: {
    // border: "2px solid pink",
    padding: 10,
  },
  modifiergroupContainer: {
    marginLeft: 30,
  },
  modifierarticleContent: {
    display: "flex",
    alignItems: "center",
  },
  rootTitle: { marginRight: 40 },
  rootDialog: { paddingBottom: 0 },
  rootButton: { color: "green", height: 16, alignSelf: "flex-start" },
}));

function AddModifierarticleDialog(props) {
  const classes = useStyles();
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [, closeDialog] = useDialog();
  const [searchValue, setSearchValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const allOptions = [];
  Object.keys(articlesStore.modifiergroups).map((id) => {
    const groupName = articlesStore.modifiergroups[id].name;
    articlesStore.modifiergroups[id].modifierarticleIds.forEach((id) =>
      allOptions.push(
        Object.assign(new Modifierarticle(), { ...articlesStore.modifierarticles[id], groupName: groupName })
      )
    );
  });
  const [errorMessage, setErrorMessage] = React.useState(null);

  let loading = open && options.length === 0;

  const search = (searchValue) => {
    if (!articlesStore.modifierarticles) {
      return [];
    }

    let searchResults = allOptions.reduce((options, option) => {
      if (options.length > 9) {
        return options;
      }
      let searchValues = searchValue.split(/\s/);

      if (
        searchValues.every((value) => {
          if (value.length === 0) {
            return true;
          }
          if (option.name.toLowerCase().includes(value.toLowerCase())) {
            return true;
          }
          return false;
        })
      ) {
        options.push(option);
      }

      return options;
    }, []);

    return searchResults;
  };

  useEffect(() => {
    if (selectedOption) {
      setSelectedOption(null);
      const oldValues = [...selectedItems];
      oldValues.push(selectedOption);
      let allIds = [...props.modifiergroup.modifierarticleIds];
      allIds = allIds.concat(selectedItems.id);
      if (allIds.includes(selectedOption.id)) {
        setErrorMessage("group_already_has_this_option");
        return;
      } else {
        setSelectedItems(oldValues);
      }
    }
  }, [selectedOption]);

  useEffect(() => {
    let active = true;

    (async () => {
      const options = await search(searchValue);
      if (active) {
        setOptions(options);
      }
    })();

    return () => {
      active = false;
    };
  }, [searchValue]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const handleCloseDialog = () => {
    if (selectedItems.length > 0) {
      const cancel = window.confirm(props.intl.formatMessage({ id: "unsaved_changes_will_be_lost" }));
      if (cancel === true) {
        closeDialog();
      }
    } else {
      closeDialog();
    }
  };

  const handleAddModifierarticles = () => {
    let modifierarticleIdsArray = [...props.modifiergroup.modifierarticleIds];
    modifierarticleIdsArray = modifierarticleIdsArray.concat(selectedItems.map((options) => options.id));
    updateModifiergroups(
      cloudStore.merchant.id,
      [props.modifiergroup],
      [
        {
          modifierarticleIds: modifierarticleIdsArray,
        },
      ]
    );
  };

  const handleRemoveNewModifierarticle = (id) => {
    const copyNewModifierarticleIds = [...selectedItems];
    const index = copyNewModifierarticleIds.indexOf(id);
    copyNewModifierarticleIds.splice(index, 1);
    setSelectedItems(copyNewModifierarticleIds);
  };

  return (
    <>
      <DialogTitle id="form-dialog-title">
        <div style={{ display: "flex" }}>
          <Typography variant={"h5"} classes={{ h5: classes.rootTitle }}>
            {props.intl.formatMessage({ id: "add_existing_modifierarticles" })}
          </Typography>
        </div>
        <IconButton
          onClick={handleCloseDialog}
          color="primary"
          style={{ position: "absolute", top: "8px", right: "8px" }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent classes={{ root: classes.rootDialog }} key={"key"}>
        <Autocomplete
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          filterOptions={(x) => x}
          noOptionsText={"no options"}
          fullWidth
          id="grouped-demo"
          options={options}
          groupBy={(option) => option.groupName}
          onChange={(e, value) => {
            if (value) {
              setSelectedOption(value);
            }
          }}
          onInputChange={(event, value) => {
            setSearchValue(value);
          }}
          getOptionLabel={(option) => option.name}
          inputValue={searchValue}
          loading={loading}
          renderInput={(params) => (
            <TextField {...params} label={props.intl.formatMessage({ id: "options" })} variant="outlined" />
          )}
        />
        {errorMessage != null && (
          <Typography style={{ color: "red", fontSize: 12 }}>
            {props.intl.formatMessage({ id: errorMessage })}
          </Typography>
        )}
        <div className={classes.modifiergroupContainer}>
          <Typography style={{ margin: 8 }}>{props.modifiergroup.name}</Typography>
          {props.modifiergroup.getModifierarticles(articlesStore.modifierarticles).map((modifierarticle) => {
            return (
              <div key={selectedItems + modifierarticle.id} className={classes.modifierarticleContent}>
                <EditSwitch
                  value={modifierarticle.manual_active}
                  authorizationField={"modifierarticle.manual_active"}
                  disabled={true}
                />
                <Typography style={{ margin: "0 8px" }}>{modifierarticle.name}</Typography>
                <Typography>{GetCurrency() + " " + (modifierarticle.price / 100).toFixed(2)}</Typography>
              </div>
            );
          })}
        </div>
        <div className={classes.modifiergroupContainer}>
          {selectedItems.map((modifierarticle) => {
            return (
              <div key={modifierarticle.id} className={classes.modifierarticleContent}>
                <EditSwitch
                  value={modifierarticle.manual_active}
                  authorizationField={"modifierarticle.manual_active"}
                  disabled={true}
                />
                <Typography style={{ margin: "0 8px", color: "green" }}>{modifierarticle.name}</Typography>
                <Typography style={{ color: "green" }}>
                  {GetCurrency() + " " + (modifierarticle.price / 100).toFixed(2)}
                </Typography>
                <IconButton onClick={() => handleRemoveNewModifierarticle(modifierarticle.id)} size={"small"}>
                  <CloseIcon classes={{ root: classes.rootButton }} size={"small"} />
                </IconButton>
              </div>
            );
          })}
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleAddModifierarticles();
            closeDialog();
          }}
        >
          {props.intl.formatMessage({ id: "add" })}
        </Button>
      </DialogActions>
    </>
  );
}

export default withIntl(AddModifierarticleDialog);
